module.exports = __webpack_public_path__ + "static/media/lappy.81ff139b.png";